/**
 * REGISTER FORM FLOATING LABELS
 *
 * Adds floating label behavior to Helium Customer Fields in the register drawer
 */

document.addEventListener('DOMContentLoaded', () => {
  const registerDrawer = document.querySelector('#register');

  if (!registerDrawer) return;

  // Function to update label state
  const updateLabelState = (field, input) => {
    if (input.value && input.value.length > 0) {
      field.classList.add('cf-field--has-value');
    } else {
      field.classList.remove('cf-field--has-value');
    }
  };

  // Get all text, email, and password fields
  const fields = registerDrawer.querySelectorAll(
    '.cf-field[data-cf-field-type="text"], .cf-field[data-cf-field-type="email"], .cf-field[data-cf-field-type="password"]'
  );

  fields.forEach(field => {
    const input = field.querySelector('input');

    if (!input) return;

    // Add focus class on focus
    input.addEventListener('focus', () => {
      field.classList.add('cf-field--has-focus');
    });

    // Remove focus class on blur
    input.addEventListener('blur', () => {
      field.classList.remove('cf-field--has-focus');
      updateLabelState(field, input);
    });

    // Update on input
    input.addEventListener('input', () => {
      updateLabelState(field, input);
    });

    // Check initial state
    updateLabelState(field, input);
  });

  // Observer to handle dynamically added fields (if Helium adds them after page load)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches && node.matches('.cf-field')) {
          const input = node.querySelector('input');
          if (input) {
            input.addEventListener('focus', () => {
              node.classList.add('cf-field--has-focus');
            });
            input.addEventListener('blur', () => {
              node.classList.remove('cf-field--has-focus');
              updateLabelState(node, input);
            });
            input.addEventListener('input', () => {
              updateLabelState(node, input);
            });
            updateLabelState(node, input);
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(registerDrawer, { childList: true, subtree: true });
});

